import type { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

function Ico({ size = 16, children, ...props }: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="ico"
      {...props}
    >
      {children}
    </svg>
  );
}

export function Book(props: IconProps) {
  return (
    <Ico {...props}>
      <rect x="2" y="2" width="12" height="12" rx="1.5" />
      <line x1="5" y1="6" x2="11" y2="6" />
      <line x1="5" y1="9" x2="9" y2="9" />
    </Ico>
  );
}

export function Calendar(props: IconProps) {
  return (
    <Ico {...props}>
      <rect x="2" y="3" width="12" height="11" rx="1.5" />
      <line x1="2" y1="7" x2="14" y2="7" />
      <line x1="5" y1="1.5" x2="5" y2="4.5" />
      <line x1="11" y1="1.5" x2="11" y2="4.5" />
    </Ico>
  );
}

export function Users(props: IconProps) {
  return (
    <Ico {...props}>
      <circle cx="6" cy="6" r="2.5" />
      <path d="M1.5 13.5c0-2.5 2-4 4.5-4s4.5 1.5 4.5 4" />
      <circle cx="11.5" cy="5.5" r="2" />
      <path d="M14.5 13.5c0-2-1.5-3.5-3-3.5" />
    </Ico>
  );
}

export function List(props: IconProps) {
  return (
    <Ico {...props}>
      <line x1="3" y1="5" x2="13" y2="5" />
      <line x1="3" y1="8" x2="13" y2="8" />
      <line x1="3" y1="11" x2="13" y2="11" />
    </Ico>
  );
}

export function Building(props: IconProps) {
  return (
    <Ico {...props}>
      <rect x="2" y="2" width="12" height="12" rx="1" />
      <rect x="5" y="8" width="2.5" height="6" />
      <rect x="8.5" y="8" width="2.5" height="6" />
      <rect x="5" y="4.5" width="2" height="2" />
      <rect x="9" y="4.5" width="2" height="2" />
    </Ico>
  );
}

export function Storefront(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M2 6.5l1.5-4h9l1.5 4" />
      <path d="M2 6.5c0 1 .7 1.5 1.5 1.5S5 7.5 5 6.5c0 1 .7 1.5 1.5 1.5S8 7.5 8 6.5c0 1 .7 1.5 1.5 1.5S11 7.5 11 6.5c0 1 .7 1.5 1.5 1.5S14 7.5 14 6.5" />
      <rect x="3" y="10" width="4" height="4" />
      <rect x="9" y="9.5" width="4" height="4.5" />
    </Ico>
  );
}

export function Chart(props: IconProps) {
  return (
    <Ico {...props}>
      <line x1="2" y1="14" x2="14" y2="14" />
      <rect x="3" y="9" width="2.5" height="5" />
      <rect x="6.75" y="5" width="2.5" height="9" />
      <rect x="10.5" y="7" width="2.5" height="7" />
    </Ico>
  );
}

export function Clipboard(props: IconProps) {
  return (
    <Ico {...props}>
      <rect x="3" y="3" width="10" height="11" rx="1.5" />
      <path d="M6 3V2h4v1" />
      <line x1="5.5" y1="7" x2="10.5" y2="7" />
      <line x1="5.5" y1="10" x2="8.5" y2="10" />
    </Ico>
  );
}

export function Pulse(props: IconProps) {
  return (
    <Ico {...props}>
      <polyline points="2,8 5,8 6.5,4 8,12 9.5,6 11,8 14,8" />
    </Ico>
  );
}

export function Gear(props: IconProps) {
  return (
    <Ico {...props}>
      <circle cx="8" cy="8" r="2.5" />
      <path d="M8 2v1.5M8 12.5V14M2 8h1.5M12.5 8H14M3.5 3.5l1 1M11.5 11.5l1 1M12.5 3.5l-1 1M4.5 11.5l-1 1" />
    </Ico>
  );
}

export function Logout(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M6 3H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3" />
      <polyline points="11,5 14,8 11,11" />
      <line x1="14" y1="8" x2="6" y2="8" />
    </Ico>
  );
}

export function Search(props: IconProps) {
  return (
    <Ico {...props}>
      <circle cx="7" cy="7" r="4.5" />
      <line x1="10.5" y1="10.5" x2="14" y2="14" />
    </Ico>
  );
}

export function Plus(props: IconProps) {
  return (
    <Ico {...props}>
      <line x1="8" y1="3" x2="8" y2="13" />
      <line x1="3" y1="8" x2="13" y2="8" />
    </Ico>
  );
}

export function Download(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M8 3v7M5 7l3 3 3-3" />
      <path d="M3 12v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1" />
    </Ico>
  );
}

export function Eye(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M2 8c1.5-3 3.5-4.5 6-4.5S12.5 5 14 8c-1.5 3-3.5 4.5-6 4.5S3.5 11 2 8Z" />
      <circle cx="8" cy="8" r="2" />
    </Ico>
  );
}

export function Edit(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M11 2.5 13.5 5l-8 8L3 14l.5-2.5 8-9Z" />
      <line x1="9.5" y1="4" x2="12" y2="6.5" />
    </Ico>
  );
}

export function Trash(props: IconProps) {
  return (
    <Ico {...props}>
      <polyline points="3,5 4,5 12,5" />
      <path d="M5 5V13a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V5" />
      <path d="M6 5V3h4v2" />
    </Ico>
  );
}

export function Mail(props: IconProps) {
  return (
    <Ico {...props}>
      <rect x="2" y="4" width="12" height="9" rx="1" />
      <polyline points="2,4 8,9 14,4" />
    </Ico>
  );
}

export function X(props: IconProps) {
  return (
    <Ico {...props}>
      <line x1="4" y1="4" x2="12" y2="12" />
      <line x1="12" y1="4" x2="4" y2="12" />
    </Ico>
  );
}

export function Check(props: IconProps) {
  return (
    <Ico {...props}>
      <polyline points="3,8 6.5,12 13,4" />
    </Ico>
  );
}

export function ChevL(props: IconProps) {
  return (
    <Ico {...props}>
      <polyline points="10,4 6,8 10,12" />
    </Ico>
  );
}

export function ChevR(props: IconProps) {
  return (
    <Ico {...props}>
      <polyline points="6,4 10,8 6,12" />
    </Ico>
  );
}

export function More(props: IconProps) {
  return (
    <Ico {...props}>
      <circle cx="4" cy="8" r="1" fill="currentColor" stroke="none" />
      <circle cx="8" cy="8" r="1" fill="currentColor" stroke="none" />
      <circle cx="12" cy="8" r="1" fill="currentColor" stroke="none" />
    </Ico>
  );
}

export function TrendUp(props: IconProps) {
  return (
    <Ico {...props}>
      <polyline points="2,11 6,7 9,10 14,5" />
      <polyline points="11,5 14,5 14,8" />
    </Ico>
  );
}

export function TrendDown(props: IconProps) {
  return (
    <Ico {...props}>
      <polyline points="2,5 6,9 9,6 14,11" />
      <polyline points="11,11 14,11 14,8" />
    </Ico>
  );
}

export function Tag(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M2 2h5l7 7a2 2 0 0 1 0 2.8l-2.2 2.2a2 2 0 0 1-2.8 0L2 7V2Z" />
      <circle cx="5.5" cy="5.5" r="1" fill="currentColor" stroke="none" />
    </Ico>
  );
}

export function Key(props: IconProps) {
  return (
    <Ico {...props}>
      <circle cx="5.5" cy="7.5" r="3.5" />
      <path d="M9 7.5h5M12 7.5v2" />
    </Ico>
  );
}

export function Fingerprint(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M8 3a5 5 0 0 1 5 5" />
      <path d="M3 8a5 5 0 0 1 5-5" />
      <path d="M8 11c0 1.5-.5 3-1 4" />
      <path d="M5.5 11A2.5 2.5 0 0 1 8 8" />
      <path d="M10.5 8A2.5 2.5 0 0 1 8 10.5" />
      <path d="M3.5 6c.5-2 2.5-3.5 4.5-3.5" />
    </Ico>
  );
}

export function Globe(props: IconProps) {
  return (
    <Ico {...props}>
      <circle cx="8" cy="8" r="6" />
      <path d="M8 2c-2 2-3 4-3 6s1 4 3 6" />
      <path d="M8 2c2 2 3 4 3 6s-1 4-3 6" />
      <line x1="2" y1="8" x2="14" y2="8" />
    </Ico>
  );
}

export function Pin(props: IconProps) {
  return (
    <Ico {...props}>
      <circle cx="8" cy="6.5" r="3" />
      <path d="M8 14c-2-2-5-4.5-5-7.5a5 5 0 0 1 10 0c0 3-3 5.5-5 7.5Z" />
    </Ico>
  );
}

export function Code(props: IconProps) {
  return (
    <Ico {...props}>
      <polyline points="5,4 2,8 5,12" />
      <polyline points="11,4 14,8 11,12" />
    </Ico>
  );
}

export function AlertTriangle(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M8 3 1.5 13.5h13L8 3Z" />
      <line x1="8" y1="7" x2="8" y2="10" />
      <circle cx="8" cy="11.5" r=".5" fill="currentColor" stroke="none" />
    </Ico>
  );
}

export function CheckIn(props: IconProps) {
  return (
    <Ico {...props}>
      <polyline points="3,8 6.5,12 13,4" />
      <circle cx="8" cy="8" r="6" />
    </Ico>
  );
}

export function Lock(props: IconProps) {
  return (
    <Ico {...props}>
      <rect x="3.5" y="7" width="9" height="7" rx="1" />
      <path d="M5 7V5a3 3 0 0 1 6 0v2" />
    </Ico>
  );
}

export function Refresh(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M13.5 8A5.5 5.5 0 1 1 8 2.5" />
      <polyline points="8,2.5 11,2.5 11,5.5" />
    </Ico>
  );
}

export function Clock(props: IconProps) {
  return (
    <Ico {...props}>
      <circle cx="8" cy="8" r="6" />
      <path d="M8 5v3l2 1.3" />
    </Ico>
  );
}

export function Heart(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M8 14s-5-3-5-7a3.3 3.3 0 0 1 5-2.8A3.3 3.3 0 0 1 13 7c0 4-5 7-5 7z" />
    </Ico>
  );
}

export function Hamburger(props: IconProps) {
  return (
    <Ico {...props}>
      <path d="M2 4h12M2 8h12M2 12h12" />
    </Ico>
  );
}
